export const Test = "Test" as const;
export const Test2 = "Test2" as const;
export const Test3 = "Test3" as const;

// create campaign types 
export const CREATE_CAMPAIGN = "CREATE CAMPAIGN" as const;
export const CREATE_CAMPAIGN_START = "CREATE CAMPAIGN START" as const;
export const CREATE_CAMPAIGN_DATE = "CREATE CAMPAIGN DATA" as const;
export const CREATE_CAMPAIGN_END = "CREATE CAMPAIGN END" as const;
export const GET_CAMPAIGN_FIELD = "GET CAMPAIGN FIELD" as const;
export const GET_UNAPPROVED_FILES = "GET UNAPPROVED FILES" as const;



export const LOGIN_START = "LOGIN_START" as const;
export const LOGIN_SUCCESS  = "LOGIN_SUCCESS " as const;
export const LOGIN_FAILURE  = "LOGIN_FAILURE " as const;

export const GET_CAMPAIGN = "GET CAMPAIGN" as const;
export const GET_CAMPAIGN_START  = "GET CAMPAIGN START" as const;
export const GET_CAMPAIGN_DATA  = "GET CAMPAIGN DATA" as const;
export const GET_CAMPAIGN_END = "GET CAMPAIGN END" as const;

export const GET_CAMPAIGN_COMPLETED = "GET CAMPAIGN COMPLETED" as const;
export const GET_CAMPAIGN_COMPLETED_START  = "GET CAMPAIGN COMPLETED START" as const;
export const GET_CAMPAIGN_COMPLETED_DATA  = "GET CAMPAIGN COMPLETED DATA" as const;
export const GET_CAMPAIGN_COMPLETED_END = "GET CAMPAIGN COMPLETED END" as const;
export const GET_CAMPAIGN_COMPLETED_WINNER = "GET CAMPAIGN COMPLETED WINNER" as const;
export const GET_CAMPAIGN_COMPLETED_WINNER_TRANSACTIONS = "GET CAMPAIGN COMPLETED WINNER_TRANSACTIONS" as const;
export const GET_CAMPAIGN_COMPLETED_HISTORY_TRANSACTIONS = "GET CAMPAIGN COMPLETED_HISTORY_TRANSACTIONS" as const;


export const GET_REPORTING = "GET REPORTING" as const;
export const GET_REPORTING_START  = "GET REPORTING START" as const;
export const GET_REPORTING_DATA  = "GET REPORTING DATA" as const;
export const GET_REPORTING_END = "GET REPORTING END" as const;




export const TEMPLATE_MAPPING_START = "TEMPLATE MAPPING START" as const;
export const TEMPLATE_MAPPING_DATA  = "TEMPLATE MAPPING DATA" as const;
export const TEMPLATE_DB_FIELD  = "TEMPLATE DB FIELD" as const;
export const TEMPLATE_MAPPING_EDIT  = "TEMPLATE MAPPING EDIT" as const;
export const TEMPLATE_MAPPING_END = "TEMPLATE MAPPING END" as const;



export const USER_START = "USER START" as const;
export const USER_DATA  = "USER DATA" as const;
export const USER_CREATE  = "USER CREATE" as const;
export const USER_UPDATE  = "USER UPDATE" as const;
export const USER_EDIT  = "USER EDIT" as const;
export const USER_DELETE  = "USER DELETE" as const;
export const USER_END = "USER END" as const;



export const ROLE_START = "ROLE_START" as const;
export const ROLE_DATA  = "ROLE_DATA" as const;
export const ROLE_END  = "ROLE_END" as const;
export const ROLE_GETBY = "ROLE_GETBY" as const;
export const ROLE_UPDATE = "ROLE_UPDATE" as const;
export const ROLE_PERMISSION = "ROLE PERMISSION" as const;
export const ROlE_CREATE = "ROLE CREATE" as const;




export const TRANSACTION_START = "TRANSACTION_START" as const;
export const TRANSACTION_DATA  = "TRANSACTION_DATA" as const;
export const TRANSACTION_END  = "TRANSACTION_ROLE_END" as const;




export const AUDITS_START = "AUDITS_START" as const;
export const AUDITS_DATA  = "AUDITS_DATA" as const;
export const AUDITS_END  = "AUDITS_END" as const;



export const SCREENMAKER_START = "SCREENMAKER_START" as const;
export const SCREENMAKER_DATA  = "SCREENMAKER_DATA" as const;
export const SCREENMAKER_END  = "SCREENMAKER_END" as const;




export const NOTIFICATION_CONFIG = "NOTIFICATION_CONFIG" as const;
export const NOTIFICATION_CONFIG_START = "NOTIFICATION_CONFIG_START" as const;
export const NOTIFICATION_CONFIG_DATA = "NOTIFICATION_CONFIG_DATA" as const;
export const NOTIFICATION_CONFIG_END = "NOTIFICATION_CONFIG_END" as const;
export const NOTIFICATION_CONFIG_GETBY = "NOTIFICATION_CONFIG_GETBY" as const;
export const NOTIFICATION_CONFIG_CREATE = "NOTIFICATION_CONFIG_CREATE" as const;
export const NOTIFICATION_CONFIG_UPDATE = "NOTIFICATION_CONFIG_UPDATE" as const;
export const NOTIFICATION_CONFIG_DELETE = "NOTIFICATION_CONFIG_DELETE" as const;

export const AD_CONFIG_START = "AD_CONFIG_START" as const;
export const AD_CONFIG_DATA  = "AD_CONFIG_DATA" as const;
export const AD_CONFIG_SAVE  = "AD_CONFIG_SAVE" as const;
export const AD_CONFIG_END   = "AD_CONFIG_END" as const;

export const PASSWORD_POLICY_START  = "PASSWORD_POLICY_START" as const;
export const PASSWORD_POLICY_DATA   = "PASSWORD_POLICY_DATA" as const;
export const PASSWORD_POLICY_UPSERT = "PASSWORD_POLICY_UPSERT" as const;
export const PASSWORD_POLICY_DELETE = "PASSWORD_POLICY_DELETE" as const;
export const PASSWORD_POLICY_END    = "PASSWORD_POLICY_END" as const;

export const BLACKLIST_CREATE = "BLACKLIST_CREATE" as const;
export const BLACKLIST_DELETE = "BLACKLIST_DELETE" as const;

export const GET_CAMPAIGN_WITH_STATUS = "GET_CAMPAIGN_WITH_STATUS" as const;

export const INSTITUTION_START = "INSTITUTION_START" as const;
export const INSTITUTION_DATA  = "INSTITUTION_DATA" as const;
export const INSTITUTION_END   = "INSTITUTION_END" as const;

export const SMTP_CONFIG_START  = "SMTP_CONFIG_START" as const;
export const SMTP_CONFIG_DATA   = "SMTP_CONFIG_DATA" as const;
export const SMTP_CONFIG_END    = "SMTP_CONFIG_END" as const;
export const SMTP_CONFIG_SAVE   = "SMTP_CONFIG_SAVE" as const;
export const SMTP_CONFIG_TEST   = "SMTP_CONFIG_TEST" as const;

export const NOTIFY_SMTP_START  = "NOTIFY_SMTP_START" as const;
export const NOTIFY_SMTP_DATA   = "NOTIFY_SMTP_DATA" as const;
export const NOTIFY_SMTP_UPSERT = "NOTIFY_SMTP_UPSERT" as const;
export const NOTIFY_SMTP_DELETE = "NOTIFY_SMTP_DELETE" as const;
export const NOTIFY_SMTP_END    = "NOTIFY_SMTP_END" as const;

export const BLACKLIST_GET_START = "BLACKLIST_GET_START" as const;
export const BLACKLIST_GET_DATA  = "BLACKLIST_GET_DATA" as const;
export const BLACKLIST_GET_END   = "BLACKLIST_GET_END" as const;
